import React, { useEffect, useMemo } from 'react';
import { Field } from 'formik';

import { useActions } from '../../../hooks/useActions';
import { useSelector } from '../../../hooks/useSelector';

import FormSelectSearchField from '../formSelectSearchField/FormSelectSearchField';
import SelectedList from '../selectedList/SelectedList';
import MyCheckbox from '../../elements/checkbox/Checkbox';

import './SecondPage.css';
import { useCallback } from 'react';
import { INVITE_ALL_USERS } from '../../../constants/post';
const SecondPage = ({ page, values, setValues, errors, touched, handleChange }) => {
    const { fetchUserTeams, fetchUsers } = useActions();
    const teams = useSelector(state => state.invitePeople.allUserTeams);
    const individuals = useSelector(state => state.invitePeople.allUsers);

    const individualsFromTeams = useMemo(() => {
        const usersFromTeams = [
            ...new Set(teams.reduce((sum, curr) => sum.concat(curr.invitedUsers), [])),
        ];
        return individuals.filter(individual => usersFromTeams.includes(individual.email));
    }, [teams, individuals]);

    useEffect(() => {
        fetchUserTeams();
        fetchUsers();
    }, []);

    const handleChangePublic = useCallback(
        e => {
            setValues(prevValues => ({
                ...prevValues,
                invitedTeams: !values.isPublicPost ? [...teams] : [],
                invitedIndividuals: !values.isPublicPost ? [INVITE_ALL_USERS] : [],
            }));
            handleChange(e);
        },
        [values, setValues]
    );

    return (
        <div id="secondPage" className="secondPage">
            <div className="fieldWrapper isPublicPost">
                <label htmlFor="isPublicPost" className="label-is-public">
                    <MyCheckbox name="isPublicPost" values={values} setValues={setValues} />
                    <Field
                        className="inputIsPublicPost"
                        id="isPublicPost"
                        name="isPublicPost"
                        type="checkbox"
                        onChange={handleChangePublic}
                    />
                    <div className="isPublicDescr">
                        <h2>Public</h2>
                        <p>The published project will be visible to all users of the network</p>
                    </div>
                </label>
            </div>
            <div className="fieldWrapper invitePeople">
                <div className="inviteTeams">
                    <h2>Invite Team</h2>
                    <FormSelectSearchField
                        name="invitedTeams"
                        searchHeader="Search new team"
                        header="Teams"
                        headerWithSearch="Invite Team"
                        list={teams}
                        values={values}
                        setValues={setValues}
                    />
                    {!!values.invitedTeams.length && !values.isPublicPost && (
                        <SelectedList
                            name="invitedTeams"
                            field="selectedList"
                            items={values.invitedTeams}
                            values={values}
                            setValues={setValues}
                        />
                    )}
                </div>
                <div className="inviteIndividuals">
                    <h2>Invite Individuals</h2>
                    <div className="select-with-tooltip">
                        <FormSelectSearchField
                            name="invitedIndividuals"
                            searchHeader="Search or add new freelancer"
                            header="Individuals"
                            headerWithSearch="Invite Individuals"
                            list={individualsFromTeams}
                            values={values}
                            setValues={setValues}
                        />
                        {/* <div className="formTooltip invitePeopleTooltip">
                            You can invite a freelancer from your team or a freelancer from outside.
                        </div> */}
                    </div>
                    {!!values.invitedIndividuals.length && !values.isPublicPost && (
                        <SelectedList
                            name="invitedIndividuals"
                            field="selectedList"
                            items={values.invitedIndividuals}
                            values={values}
                            setValues={setValues}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default React.memo(SecondPage);
